import { useRequiredContext } from '@cascade/react/hooks';
import { createContext } from 'react';
import type { TLayoutContext } from './Layout.types.ts';

export const LayoutContext = createContext<TLayoutContext | undefined>(
  undefined,
);

export const useLayout = (): TLayoutContext =>
  useRequiredContext(
    LayoutContext,
    'useLayout is only available inside a Layout',
  );
